// 用户数据
export const users = [
  {
    id: 1,
    username: "admin",
    password: "123456",
    name: "好奇分享站",
    avatar: "https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg",
    intro: "热爱分享技术干货的程序员",
    details: "专注于前端开发、Linux运维和Java技术分享",
    email: "admin@blog.com",
    techStack: "React, Node.js, Java, Linux",
    interests: "编程、阅读、旅行",
    github: "https://github.com",
    linkedin: "https://linkedin.com",
    personalHomepage: "#",
    role: "admin"
  },
  {
    id: 2,
    username: "user1",
    password: "123456",
    name: "技术爱好者",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    intro: "技术探索者",
    details: "热爱学习新技术",
    email: "user1@blog.com",
    techStack: "JavaScript, Python",
    interests: "编程、游戏",
    github: "#",
    linkedin: "#",
    personalHomepage: "#",
    role: "user"
  }
];

// 默认关于信息模板
export const defaultAboutInfoTemplate = {
  name: '未设置昵称',
  avatar: 'https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg',
  intro: '这个人很神秘，什么也没留下。',
  details: '欢迎来到我的博客！请登录后完善您的个人信息！',
  email: '未设置邮箱',
  techStack: '暂无',
  interests: '暂无',
  github: '#',
  linkedin: '#',
  personalHomepage: '#',
};

// 文章数据
export const posts = [
  {
    id: "1766735622630",
    title: "武汉美食打卡全攻略：在烟火气里吃透江湖味",
    author: "pigStar",
    authorId: 2,
    date: "2025-12-26 15:53:42",
    tags: ["武汉", "美食", "攻略"],
    summary: "武汉的美食，从来都藏在市井烟火里。热干面的芝麻酱香飘满老巷，糊汤粉的鲜气裹着油条钻进鼻腔，小龙虾的麻辣在夏夜的排档里沸腾...",
    content: `<h2>早餐：热干面与糊汤粉</h2>
              <p>武汉人的一天从热干面开始。推荐老字号"蔡林记"，芝麻酱香浓，面条劲道。</p>
              <p>糊汤粉配油条是另一绝，鱼汤熬煮的米粉鲜美无比。</p>
              
              <h2>午餐：武昌鱼与莲藕排骨汤</h2>
              <p>午餐必尝清蒸武昌鱼，鲜嫩可口。</p>
              <p>莲藕排骨汤是湖北特色，汤鲜藕糯。</p>
              
              <h2>晚餐：小龙虾与烧烤</h2>
              <p>晚上去吉庆街或万松园，麻辣小龙虾和烧烤是绝配。</p>
              
              <h2>小吃：豆皮与面窝</h2>
              <p>不要错过三鲜豆皮和面窝，武汉小吃的代表。</p>`,
    category: "生活",
    readCount: 156,
    likes: 34
  },
  {
    id: "1766735622631",
    title: "JDK各版本官方下载地址",
    author: "admin",
    authorId: 1,
    date: "2025-01-10 09:20:15",
    tags: ["Java", "JDK", "开发环境"],
    summary: "我负责的一个系统用的是JDK版本是8u111，前几天部署的时候由于官网下载需要账号，于是网上随便下了个JDK版本。结果就出问题了...",
    content: `<h2>JDK官方下载地址</h2>
              <p>正确的JDK官方下载地址：https://www.oracle.com/java/technologies/downloads/</p>
              
              <h2>JDK 8u111 下载说明</h2>
              <p>如果需要历史版本，可以访问：https://www.oracle.com/java/technologies/javase/javase8-archive-downloads.html</p>
              
              <h2>Linux下JDK下载方法</h2>
              <p>使用wget命令下载，注意添加no-check-certificate参数：</p>
              <pre><code>wget --no-check-certificate --no-cookies --header "Cookie: oraclelicense=accept-securebackup-cookie" [下载链接]</code></pre>
              
              <h2>安装注意事项</h2>
              <p>1. 验证文件完整性（MD5或SHA256）</p>
              <p>2. 配置环境变量（JAVA_HOME, PATH）</p>
              <p>3. 测试安装是否成功：java -version</p>`,
    category: "技术",
    readCount: 378,
    likes: 42
  },
  {
    id: "1766735622632",
    title: "Linux负载累增的检查命令",
    author: "admin",
    authorId: 1,
    date: "2025-01-08 14:30:22",
    tags: ["Linux", "服务器", "运维"],
    summary: "Linux系统中，负载均衡是系统性能的重要指标。uptime命令可以快速查看机器的负载情况...",
    content: `<h2>1. uptime命令</h2>
              <p>命令：<code>uptime</code></p>
              <p>输出示例：23:51:26 up 21:31, 1 user, load average: 30.02, 26.43, 19.02</p>
              <p>解释：显示当前时间、运行时间、登录用户数、系统平均负载（1分钟、5分钟、15分钟）</p>
              
              <h2>2. top命令</h2>
              <p>命令：<code>top</code></p>
              <p>实时显示进程状态，按P按CPU使用率排序，按M按内存使用率排序</p>
              
              <h2>3. htop命令（增强版top）</h2>
              <p>需要安装：<code>sudo apt install htop</code></p>
              <p>提供彩色界面、鼠标支持、更好的可视化</p>
              
              <h2>4. vmstat命令</h2>
              <p>命令：<code>vmstat 1 10</code>（每秒一次，共10次）</p>
              <p>显示虚拟内存统计、进程、CPU活动</p>
              
              <h2>5. mpstat命令</h2>
              <p>命令：<code>mpstat -P ALL 1</code></p>
              <p>显示每个CPU核心的使用情况</p>
              
              <h2>6. sar命令</h2>
              <p>系统活动报告器，需要安装sysstat包</p>
              <p><code>sar -u 1 5</code>：CPU使用率</p>
              <p><code>sar -r 1 5</code>：内存使用率</p>`,
    category: "技术",
    readCount: 1979,
    likes: 89
  },
  {
    id: "1766735622633",
    title: "React Hooks 最佳实践",
    author: "admin",
    authorId: 1,
    date: "2025-01-05 11:15:30",
    tags: ["React", "前端", "Hooks"],
    summary: "React Hooks 是 React 16.8 引入的新特性，它让我们在函数组件中也能使用状态和其他 React 特性...",
    content: `<h2>useState 使用规范</h2>
              <p>1. 使用函数式更新确保状态更新的正确性</p>
              <p>2. 复杂状态使用 useReducer 替代多个 useState</p>
              
              <h2>useEffect 清理副作用</h2>
              <p>每次 useEffect 执行前都会清理上一次的副作用</p>
              <p>返回清理函数防止内存泄漏</p>
              
              <h2>自定义 Hooks</h2>
              <p>将可复用的逻辑提取为自定义 Hooks</p>
              <p>以 use 开头命名，符合 React Hooks 规则</p>`,
    category: "技术",
    readCount: 892,
    likes: 56
  },
  {
    id: "1766735622634",
    title: "Ant Design 在项目中的应用",
    author: "user1",
    authorId: 2,
    date: "2024-12-28 16:45:10",
    tags: ["Ant Design", "UI", "React"],
    summary: "Ant Design 是企业级 UI 设计语言和 React 组件库，提供了丰富的组件和优雅的设计风格...",
    content: `<h2>布局组件</h2>
              <p>使用 Layout、Grid 组件构建页面结构</p>
              
              <h2>表单组件</h2>
              <p>Form 组件配合 Form.Item 实现复杂的表单验证</p>
              
              <h2>数据展示</h2>
              <p>Table、Card、List 组件展示结构化数据</p>`,
    category: "技术",
    readCount: 567,
    likes: 23
  }
];

// 归档数据（按年月分组）
export const getArchives = () => {
  const archives = {};
  
  posts.forEach(post => {
    const date = new Date(post.date);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const key = `${year}-${month.toString().padStart(2, '0')}`;
    
    if (!archives[key]) {
      archives[key] = {
        year,
        month,
        count: 0,
        posts: []
      };
    }
    
    archives[key].count++;
    archives[key].posts.push(post);
  });
  
  return Object.values(archives).sort((a, b) => {
    if (a.year !== b.year) return b.year - a.year;
    return b.month - a.month;
  });
};

// 获取用户信息
export const getUserInfo = (userId) => {
  const user = users.find(u => u.id === userId);
  return user || defaultAboutInfoTemplate;
};

// 模拟 API 延迟
export const simulateApiCall = (data, delay = 500) => {
  return new Promise(resolve => {
    setTimeout(() => resolve(data), delay);
  });
};